import { endpoint } from 'services/Api';
import {RESOURCE as PARENT} from 'services/api/dashboards';

/**
 * Discount Rate Comparison Dashboard Dashboard Endpoin.
 */
export default {
    /**
     * Discount Comparison Results
     *
     * @return {Promise}
     */
    results: (payload) => endpoint(`${PARENT}`, 'discount-rate-comparison', payload),
    /**
     * Discount Comparison Preview
     *
     * @return {Promise}
     */
    preview: (payload) => endpoint(`${PARENT}`, 'discount-rate-preview', payload),
    /**
     * Apply Discount Rate Update
     *
     * @return {Promise}
     */
    apply: (payload) => endpoint(`${PARENT}`, 'apply-discount-rate-update', payload),
    /**
     * Apply Discount Rate Update
     *
     * @return {Promise}
     */
    checkProgress: (payload) => endpoint(`${PARENT}`, 'discount-rate-progress', payload),
};



// WEBPACK FOOTER //
// ./src/services/api/dashboards/discountComparison.js